"use client";

import { BriefcaseIcon, EnvelopeIcon, MapPinIcon, PhoneIcon, UsersIcon } from "@heroicons/react/24/outline";
import { SafeImage } from "@shared/ui";
import { PropsWithChildren } from "react";
import { WlkpCompany } from "../model";

export const WlkpCompanyCard = ({ company, children }: { company: WlkpCompany } & PropsWithChildren) => {
  if (!company) {
    return <></>;
  }

  return (
    <div className="bg-white p-3 rounded-xl flex items-start border border-gray-200 gap-2">
      <SafeImage
        className="rounded-lg border border-gray-100 size-14 object-contain bg-gray-100 p-1"
        src={company.logoUri || ""}
        alt={company.name}
        fallback="/blank-gray.webp"
        width={56}
        height={56}
      />
      <div className="flex-1 space-y-1">
        <div className="flex flex-col sm:flex-row gap-1">
          <div className="flex-1">
            <div className="flex items-start gap-1 flex-col flex-wrap text-xs text-gray-500">
              <div>
                Kode WLKP: <span className="font-semibold">{company.wlkpCode}</span>
              </div>
              {company.nib && (
                <div>
                  NIB: <span className="font-semibold">{company.nib}</span>
                </div>
              )}
            </div>
            <div className="flex items-center gap-x-2 flex-wrap">
              <h4 className="text-base font-semibold">{company.name}</h4>
              {company.companyableType && (
                <span
                  className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
                    company.companyableType === "parent_company" ? "bg-blue-100 text-blue-700" : "bg-amber-100 text-amber-700"
                  }`}
                >
                  {company.companyableType === "parent_company" ? "Pusat" : "Cabang"}
                </span>
              )}
            </div>
          </div>
          <div>{children}</div>
        </div>
        <div className="text-sm flex items-start gap-2 text-gray-600">
          <EnvelopeIcon className="size-4 min-w-4 mt-1" />
          <span>{company.email}</span>
        </div>
        <div className="text-sm flex items-start gap-2 text-gray-600">
          <PhoneIcon className="size-4 min-w-4 mt-1" />
          <span>{company.phone}</span>
        </div>
        <div className="text-sm flex items-start gap-2 text-gray-600">
          <BriefcaseIcon className="size-4 min-w-4 mt-1" />
          <span>{company.business?.name}</span>
        </div>
        <div className="text-sm flex items-start gap-2 text-gray-600">
          <UsersIcon className="size-4 min-w-4 mt-1" />
          <span>{company.totalActiveEmployees || 0} Pekerja</span>
        </div>
        <div className="text-sm flex items-start gap-2 text-gray-600">
          <MapPinIcon className="size-4 min-w-4 mt-1" />
          <span>
            {company.address} ({company.village?.subDistrict?.city?.name}) ({company.zipCode})
          </span>
        </div>
      </div>
    </div>
  );
};
